// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__24KAp","signatureButtonsRight":"ModalSign_signatureButtonsRight__2bMy7"};